module.exports = __webpack_public_path__ + "media/Advantage.06f01bb9.mp4";